"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var apiTypeVente = _interopRequireWildcard(require("@/api/type_vente"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'TypeVenteSelectList',
  props: {
    idTypeVenteSelected: {
      type: Number,
      default: null
    },
    action: {
      type: String,
      required: true,
      validator: function validator(value) {
        return ['new', 'edit'].includes(value);
      }
    }
  },
  data: function data() {
    return {
      typeVenteList: [],
      idTypeVente: this.idTypeVenteSelected
    };
  },
  beforeMount: function beforeMount() {
    this.getAll();
  },
  methods: {
    getAll: function getAll() {
      var _this = this;

      apiTypeVente.getAll().then(function (results) {
        _this.typeVenteList = results.filter(function (x) {
          return x.actif === 1 || x.id === _this.idTypeVenteSelected;
        });

        if (_this.action === 'new') {
          var defaut = _this.typeVenteList.filter(function (x) {
            return x.actif === 1 && x.idc_defaut === 1;
          })[0];

          if (defaut) {
            _this.idTypeVente = defaut.id;
          }
        }

        _this.$emit('update:id-type-vente', _this.idTypeVente);
        /*
        this.typeVenteList = results
        const typeVente = this.typeVenteList.find(x => x.id === this.idTypeVenteSelected)
        if (typeVente) {
          this.$emit('update:type-vente', typeVente)
        }
        */

      }).catch(function (error) {
        _this.$message(error);
      });
    },
    onClear: function onClear() {
      // this.$emit('update:id-type-vente-selected', null)
      this.$emit('update:id-type-vente', null);
    },
    onChange: function onChange(index) {
      if (index > 0) {
        // this.$emit('update:id-type-vente-selected', index)
        this.$emit('update:id-type-vente', index);
      }
    }
  }
};
exports.default = _default;